/**
 * details
 */

export function details_state() {
  document.addEventListener("DOMContentLoaded", function() {
    updateDetails();
  });

  window.addEventListener("resize", function() {
    updateDetails();
  });

  function updateDetails() {
    var width = window.innerWidth;
    var detailsArray = document.getElementsByClassName('js-detail-guide');
    for (var i = 0; i < detailsArray.length; i++) {
      if (width < 896) {
        detailsArray[i].removeAttribute('open');
      } else {
        detailsArray[i].setAttribute('open', '');
      }
    }
  }
}
